import React from 'react';
import { useTranslation } from 'react-i18next';
import { Layout, Loader, Favorites } from '../../components';
import { useTags } from '../../contexts/Tag/TagContext';
import { isMobile } from '../../utils/responsive';
import { NavigationParamList, ScreenName, TabNavigationScreenProps } from '../../navigation/types';

const FavoritesScreen: React.FC<
  TabNavigationScreenProps<NavigationParamList, ScreenName.FavoritesScreen>
> = ({ navigation, route }) => {
  const { tags } = useTags();
  const { t } = useTranslation();

  return tags ? (
    <Layout title={!isMobile && t('navigation:favorites')}>
      <Favorites />
    </Layout>
  ) : (
    <Loader />
  );
};

export default FavoritesScreen;
